import { defineComponent as _defineComponent } from 'vue'
import { inject, computed, onMounted, ref } from 'vue'

  import CourseSearchItem from '@/components/course/CourseSearchItem.vue'

  import useIcons from '@/composables/useIcons'

  import type { PropType } from 'vue'
  import type { CourseSearchItem as ContentItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GenericContent',
  props: {
    content: {
      type: Array as PropType<ContentItem[]>,
      required: true,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  setup(__props) {

const props = __props;

  

  const { search404 } = useIcons()

  const itemPurpose = inject('itemPurpose')

  const offset = ref(props.limit)

  const slicedResults = computed((): ContentItem[] => {
    if (!props.content) return []
    return props.content.slice(0, offset.value)
  })

  const itemSize = computed((): number => {
    return props.content?.length || 0
  })

  onMounted(() => {
    offset.value = props.limit
  })

return { __sfc: true,props, search404, itemPurpose, offset, slicedResults, itemSize, inject, computed, onMounted, ref, CourseSearchItem, useIcons }
}

})